import { sharedShowApi } from '@/api/sharedShowApi'
import { api } from '@/api/client'
import { demoAuth } from '@/api/demoAuth'
import { endpoints } from '@/api/endpoints'
import { demoSwitchesFor } from '@/features/admin/demo/demoAdmin'
import type { LoginInput } from '@/features/auth/schemas/authSchemas'
import type { Session } from '@/features/auth/types'
import { env } from '@/lib/env'

/**
 * A demo session carries the active Standort's switches, as the real one will;
 * added here rather than in `demoAuth`, which the admin fixtures reach back into.
 */
async function withDemoSwitches(session: Promise<Session>): Promise<Session> {
  const resolved = await session
  return resolved.location
    ? { ...resolved, switches: demoSwitchesFor(resolved.location.publicId) }
    : resolved
}

export const authApi = {
  login: (input: LoginInput) =>
    env.sharedShow
      ? sharedShowApi.login(input)
      : env.demoMode
        ? withDemoSwitches(demoAuth.login(input))
        : api.post<Session>(endpoints.session, input),

  /** The answer is a whole new session: new location, new `today`, new cookie and CSRF token. */
  switchLocation: (location: string) =>
    env.sharedShow
      ? sharedShowApi.switchLocation(location)
      : env.demoMode
        ? withDemoSwitches(demoAuth.switchLocation(location))
        : api.put<Session>(endpoints.sessionLocation, { location }),

  logout: () =>
    env.sharedShow
      ? sharedShowApi.logout()
      : env.demoMode
        ? demoAuth.logout()
        : api.delete<void>(endpoints.session),
}
